// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1Y6o5","empty":"ModalGraph_empty__AA2v9"};